export default __webpack_public_path__ + "static/media/douches.e3811a47.svg";